import _ from 'lodash';

const codeIdentifiers = ['HOPDwellingUnderConstructionIndicator_ML', 'PADiminishDedCovAmt_ML', 'PADiminishDedCovEffDate_ML', 'PADecliningDeduAmount_Ext'];

function createChoiceTerm(model, onChange) {
    const res = {
        hasOptions: true,
        options: model.options,
        readOnly: false,
        validationMessage_ML: model.validationMessage_ML,
        isEditable_ML: codeIdentifiers.includes(model.codeIdentifier_ML) ? false : model.isEditable_ML,
        isVisible_ML: model.isVisible_ML,
        codeIdentifier_ML:model.codeIdentifier_ML
        
    };

    if (codeIdentifiers.includes(model.codeIdentifier_ML)) {
        res.readOnly = true;
    }

    Object.defineProperty(res, 'value', {
        get: () => {
            return model.chosenTerm;
        },
        set: (term) => {
            if (model.valueType === 'bit') {
                model.directBooleanValue = term;
            } else {
                model.chosenTerm = term;
            }
            model.updated = true;
            if (model.codeIdentifier_ML == 'PALocalDeliveryCovOther_ML' 
                || model.codeIdentifier_ML === 'PACompZeroGlass'
            || model.codeIdentifier_ML == 'HOPAdditionalFeaturesBundleOptionTerm_ML'
            || model.codeIdentifier_ML == 'PAUMBISingleVeh_ExtUMBISingleVehLimit_Ext'
            || model.codeIdentifier_ML == 'PAUMPDSingleVeh_ExtUMPDSingleVehLimit_Ext'
                || model.codeIdentifier_ML == 'HOPSplLimitBundle_Ext') {
                onChange(undefined, model.code_ML, true, true);
            } else {
                onChange(undefined, model.code_ML, true);
            }
        }
    });

    return res;
}


function createInputTerm(model, onChange) {
    let newValue = model.directValue || model.genericValue_ML || model.chosenTermValue;
    const res = {
        hasOptions: false,
        applyNewValue: () => {
            if (newValue === model.directValue || newValue === model.genericValue_ML) {
                return;
            }

            if (model.valueType === 'Other') {
                if (newValue === '') {
                    model.genericValue_ML = null;
                } else {
                    model.genericValue_ML = newValue;
                }
                if (model.codeIdentifier_ML === "HOPEarthquakeYearBuilt_Ext" || model.codeIdentifier_ML === "HOPLimitedMoldYearBuilt_Ext") {
                    model.directValue = newValue;
                }
            } else if (newValue === '') {
                model.directValue = null;
            } else {
                model.directValue = newValue;
            }

            model.updated = true;
            onChange(undefined, model.code_ML, true);
        },
        readOnly: codeIdentifiers.includes(model.codeIdentifier_ML),
        validationMessage_ML: model.validationMessage_ML,
        isEditable_ML: model.isEditable_ML,
        isVisible_ML: model.isVisible_ML
    };

    Object.defineProperty(res, 'newValue', {
        get: () => {
            return newValue;
        },
        set: (nv) => {
            newValue = nv;
        }
    });

    Object.defineProperty(res, 'value', {
        get: () => {
            if (model.valueType === 'Other' && !_.isEmpty(model.genericValue_ML)) {
                return model.genericValue_ML;
            }

            return model.directValue;
        },
        set: (nv) => {
            newValue = nv;

            if (model.valueType === 'Other') {
                model.genericValue_ML = nv;
            } else {
                model.directValue = nv;
            }

            model.updated = true;
            onChange(undefined, model.code_ML, true);
        }
    });

    return res;
}


function CovTerm(data) {
    if (data) {
        _.extend(this, data);
    }
}

CovTerm.create = (model, loading, onChange)=> {
    onChange = onChange || _.noop;

    const base = model.options && model.options.length > 0 ? createChoiceTerm(model, onChange)
        : createInputTerm(model, onChange);
    base.name = model.name;

    Object.defineProperty(base, 'updating', {
        get: loading || _.constant(false)
    });

    return Object.freeze(base);
};

export default CovTerm;
